import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading || store[NAME].gettingPreview;
export const getData = store => store[NAME].data;
export const getInitialData = store => store[NAME].initialData;
export const getSummaryData = store => store[NAME].summaryData;